import { ArticleDetail } from '@src/components/sco/Education/ArticleDetail'
import { useEducationContext } from '@src/components/sco/Education/EducationContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import { EducationPage } from '@src/templates/EducationPage'
import { useParams } from 'next/navigation'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default EducationPage(function Page() {
  const educationContext = useEducationContext()
  const routeParams = useParams() as Record<string, string | undefined> | null

  useUniversalEffect(() => {
    educationContext.setActiveSection?.('lexicon.single')
  }, [])

  return (
    <ArticleDetail
      articleSlug={`${routeParams?.lexiconArticleSlug}`}
      typeSlug={'lexicon'}
      typeTitle={'Lexicon'}
      getBreadcrumbs={article => {
        const primaryTerm = article.terms.find(t => t.isPrimary)

        return [
          {
            title: 'Lexicon',
            href: '/lexicon',
          },
          primaryTerm &&
            primaryTerm.slug !== article.slug && {
              title: primaryTerm.name,
              href: `/lexicon/${primaryTerm.slug}`,
            },
          {
            title: article.title,
            href: `/lexicon/${article.slug}`,
          },
        ].filter(Boolean)
      }}
    />
  )
})
